module.exports = __webpack_public_path__ + "media/src/images/b2b_award_logo-a20e7c2f2035f60b5565e4876e28b79d.png";